import React from "react";
import {
    Modal,
    ModalBody,
    Row,
    Col,
    UncontrolledTooltip
} from "reactstrap";
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import { closePaymentModal } from '../../../redux/actions/payments.action';
import { PDFExport } from '@progress/kendo-react-pdf';


const ModalInvoice = (props) => {
    const invoice = React.createRef();
    const { t } = useTranslation(['profile', 'common', 'plans']);
    const handleExport = (event) => {
        invoice.current.save();
    };
    const getSubscription = (price) => {
        switch (price) {
            case 0.99:
                return ('lightSub');
            case 4.79:
                return ('basicSub');
            case 4.99:
                return ('basicSub');
            case 9.99:
                return ('chadSub');
            default:
                return ('subNotDefined');
        }
    }
    return (
        <>
            <Modal className="modalInvoices modal-dialog-invoices" toggle={props.closePaymentModal} isOpen={props.invoice_modal && props.invoice_modal.display} fade={true}>
                <div className="modal-header justify-content-center">
                <div className="invoice-btns">
                    <i className="invoice-icons tim-icons icon-cloud-download-93" id="downloadPdf" onClick={handleExport}/>
                    <i className="invoice-icons tim-icons icon-simple-remove" onClick={() => props.closePaymentModal()}/>
                </div>
                </div>
                <PDFExport ref={invoice} paperSize="A4">
                    <ModalBody>
                    <div className="invoice-title">
                        <div className="invoice-number">{`${t('payment.invoice')} ${props.invoice_modal?.ipn ? `#${props.invoice_modal.ipn}` : ''}`}</div>
                    </div>
                    <Row>
                        <Col md="3" sm="4" xs="6" className="invoice-informations">
                        <div className="invoice-information">
                            <div className="invoice-information-title">
                            {t('payment.from')}
                            </div>
                            <div className="invoice-information-value">
                            <p>Gold rush</p>
                            <p>820779585 R.C.S</p>
                            <p>6 rue d'Armaillé</p>
                            <p>75017 PARIS</p>
                            <p>FRANCE</p>
                            </div>
                        </div>
                        </Col>
                        <Col md="3" sm="4" xs="6" className="invoice-informations">
                        <div className="invoice-information">
                            <div className="invoice-information-title">
                                {t('payment.date')}
                            </div>
                            <div className="invoice-information-value">
                            <p>{props.invoice_modal?.creation ? JSON.parse(props.invoice_modal.creation) : ''}</p>
                            </div>
                        </div>
                        {props.invoice_modal?.ipn && <div className="invoice-information">
                            <div className="invoice-information-title">
                            Invoice Number
                            </div>
                            <div className="invoice-information-value">
                            <p>{props.invoice_modal?.ipn}</p>
                            </div>
                        </div>}
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3" sm="4" xs="6" className="invoice-informations">
                        <div className="invoice-information">
                            <div className="invoice-information-title">
                                {t('payment.to')}
                            </div>
                            <div className="invoice-information-value">
                            <p>{props.invoice_modal?.payer?.name}</p>
                            <p>{props.invoice_modal?.payer?.street}</p>
                            <p>{props.invoice_modal?.payer?.zip}</p>
                            <p>{props.invoice_modal?.payer?.country}</p>
                            </div>
                        </div>
                        </Col>
                    </Row>
                    <div className="spacer"/>
                    <div className="invoice-items-body">
                        <Row>
                            <Col xs="9" className="invoice-information-title">{t('payment.product')}</Col>
                            <Col xs="3" className="text-right invoice-information-title">{t('payment.price')}</Col>
                            </Row>
                        <Row>
                            {props.invoice_modal?.paymentInfos?.mcGross && <Col xs="9">{t(`payment.${getSubscription(props.invoice_modal.paymentInfos.mcGross)}`)}</Col>}
                            <Col xs="3" className="text-right">{`${props.invoice_modal?.paymentInfos?.mcCurrency} ${props.invoice_modal?.paymentInfos?.mcGross}`}</Col>
                        </Row>
                        <div className="invoice-total text-right">{`${t('payment.total')}: ${props.invoice_modal?.paymentInfos?.mcCurrency} ${props.invoice_modal?.paymentInfos?.mcGross}`}</div>
                    </div>
                    </ModalBody>
                    <UncontrolledTooltip placement="left" target={'downloadPdf'}>
                        {t('payment.download')}
                    </UncontrolledTooltip>
                </PDFExport>
            </Modal>
        </>)
};

const mapDispatchToProps = {
    closePaymentModal
};

const mapStateToProps = (state) => {
    const { invoice_modal } = state.payments;
    return { invoice_modal };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalInvoice);